@for (group of fields; track group) {
    @if (group[0]?.visible) {
        <sm-form-field #fields width="100%" [class.block-100]="fullHeight" [fullHeight]="fullHeight" [form]="form" [field]="group.length == 1 ? group[0] : undefined" [multipleFields]="group.length > 1 ? group : undefined"
        [mandatoryFieldsRedAsterisk]="form.mandatoryFieldsRedAsterisk"
        [style.left] = "form.useAbsolutePositions ? '0' : undefined" [style.top] = "form.useAbsolutePositions ? '0' : undefined"></sm-form-field>
    }
}